module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.11813/img/platinum-tier-icon.svg"